import * as React from 'react';
interface props {
    value: any,
    setInputText: Function,
    defaultValue?: any,
    maxdate?: any,
    mindate?: any,
    disabled?: boolean,
};
const DatePicker = ({
    value,
    setInputText,
    defaultValue,
    maxdate,
    mindate,
    disabled,
}: props) => {
    return (
        <input
            className="form-control"
            type="date"
            value={value}
            onChange={(e) => setInputText(e.target.value)}
            defaultValue={defaultValue?.substring(0, 10)}
            max={maxdate}
            min={mindate}
            disabled={disabled}
            onKeyDown={(e) => e.preventDefault()}
        />
    );
}

export default DatePicker;